import { AppConfig } from '../services/appConfig'
import { TvBrowseLayoutModel } from '../types/flo-experience'
import { genericError, networkError } from '../widgets/modal'
import CarouselsHandler from './handlers/carouselsHandler'

export default class NavHub extends CarouselsHandler {
  private _siteId: string
  private _navId: string
  private _limit: string
  private _offset: string
  private _data: TvBrowseLayoutModel

  get pageText() {
    return 'Navigation Hub'
  }

  _onUrlParams({ siteId, navId }: { siteId: string; navId: string }) {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1])
    this._siteId = siteId
    this._navId = navId
    this._limit = urlParams.get('limit') ?? '3'
    this._offset = urlParams.get('offset') ?? '0'
    this.initNavHub()
  }

  async initNavHub() {
    this._isRoot = false

    this._setState('NotReady')

    await this.getNavHubData()

    this._data.container.items =
      this._lastCarousels.length > 0 ? this._lastCarousels : this._data.container.items

    this.tvBrowseLayout.data = this._data

    this.restoreFocus()

    this._setState('Ready')
  }

  async getNavHubData() {
    if (this._navId && this._siteId) {
      const data = await AppConfig.shared.experienceApi.getNavHub({
        site_id: this._siteId,
        nav_id: this._navId,
        limit: this._limit,
        offset: this._offset,
      })

      if (data?.error) {
        const error = data.isNetworkError ? networkError : genericError
        this.setModal(true, error)
        return
      }

      this._data = data
    }
  }
}
